export default {
  subscribes: (state) => state.subscribes};
